import React from "react";
import PlusShipping from "./PlusShipping";
import { User } from "~/common/Store/connectUserAndChat";
import { defaultUserObject } from "~/common/Store/rootReducer";

interface Props {
  hasWebPlusDiscountedShipping: boolean;
  allowWebPlusDiscountedShipping?: boolean;
  isWebstaurantPlusEligible: boolean;
  user?: User;
}

const PlusShippingLevels = ({
  hasWebPlusDiscountedShipping,
  allowWebPlusDiscountedShipping,
  isWebstaurantPlusEligible,
  user = defaultUserObject,
}: Props) => {
  let text: string | null = null;

  if (isWebstaurantPlusEligible) {
    text = "Ships free with ";
  } else if (hasWebPlusDiscountedShipping && allowWebPlusDiscountedShipping) {
    text = "Discounted shipping with ";
  }

  if (!text) return null;

  return <PlusShipping text={text} user={user} />;
};

export default PlusShippingLevels;
